module.exports = __webpack_public_path__ + "static/media/wizualizacja-80.5c9063e0.png";